import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';


export async function fetchSellers({commit, state}, text) {
    let params = { filter:text}
    console.log(new Date()+"Empezando Sellers");
    await $http.get('/api/lista-vendedores', {params} )
        .then((response) => {
            commit('setSellers', response.data.data)
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box',
        });
    })
  }

//Obtener los terceros
export async function fetchContacts({commit, state}, requestParameters = {
    params: state.params_contact
}) {
    console.log(new Date()+"Empezando Contacts");
    await $http.get('/api/vendedores-clientes', requestParameters)
        .then((response) => {
            console.log(response);
            commit('setContacts', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('contactError', error.message)
        })
}

// obtener Data libro Contable
export async function fetchReportBo({commit, state,dispatch}) {
    state.loading.module = true;
    await $http.get('/api/reporte-bo', { params : state.params})
        .then((response) => {
            commit('setreporte_bo', response.data);
            dispatch("fetchUnds", response.data.data);
            state.loading.module = false;
        })
        .catch((error) => {
            state.loading.module = false;
            Notification.error({
            title: 'Error!',
            message: 'Error',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}

export async function fetchStatesAuth({commit, state}, ) {
    await $http
        .get("/api/parametros-por-codigo/060")
        .then(response => {
            commit("setStatesAuth", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}
export async function fetchUnds({commit, state}, documents){
    let documents_id = []
    await documents.map(doc => {
        documents_id.push(doc.document_id)
    });

    let params = {
        'documents_id' : documents_id
    }
    await $http
        .post(`/api/unds`, params)
        .then(response => {
            commit("setUnds", response.data.data);
        })
        .catch(error => {
            console.error(error);
        });

} 



// WEBPACK FOOTER //
// ./src/modules/report-bo/actions.js